module.exports = __webpack_public_path__ + "static/media/fileupload.8a8b722e.svg";